import React from 'react';

import Chart from 'react-apexcharts';

const COLOR_PALETTE = ['#27B6FF', '#21005C', '#D8C2FF'];
const CHART_OPTIONS = {
    chart: {
        fontFamily: 'var(--font-sans)',
        type: 'pie',
        width: '100%',
    },
    plotOptions: {
        pie: {
            dataLabels: {
                offset: -30,
            },
        },
    },
    colors: COLOR_PALETTE,
    legend: {
        position: 'bottom',
    },
};

export default function ProcurementPieChart(props) {
    if (!props.data?.length) {
        return <div className="text-info">{$t('No data provided')}</div>;
    }

    return (
        <div className="card border-0 rounded-15px bg-white shadow tw-h-full tw-w-full">
            <div className="card-body card-widget dashboard__header_box">
                <h5 className="text-dark-blue pt-2">{props.title}</h5>
                <Chart options={{ ...CHART_OPTIONS, labels: props.labels }} series={props.data} type="pie" height={300} />
            </div>
        </div>
    );
}
